import React from "react";
import {Button, Flex, Tooltip} from "antd";
import {DownloadIcon, FileCodeIcon} from "@phosphor-icons/react";
import {useCurrentUser} from "../../../../../../contexts/UserContext";
import {useViewerStore} from "../../../../../../store/store";
import GenFilePopup from "../../../Modal/Modal-Content/GenFilePopup";
import {useAreChangesMadeToDesign} from "../../../../../../hooks/useAreChangesMadeToDesign";

const GenFileButton: React.FC = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const {hasCapability} = useCurrentUser();
    const { areChangesMade, isOriginalSite } = useAreChangesMadeToDesign();

    function openGenFilePopup() {
        useViewerStore.setState({isLeftSidebarOpen: false});

        sceneViewer.viewerAlert({
            show: true,
            title: "Download .GEN File",
            message: <GenFilePopup/>,
            messageType: "info",
            isModal: true
        })
    }

    return (
        <>
            {
                hasCapability('.GEN') &&
                <>
                    <Flex justify={'left'} align={'center'} gap={5} className={"sidebar-headings"}><FileCodeIcon size={32}/>.GEN
                        File</Flex>
                    {<Tooltip title={areChangesMade ? "Changes were made. Finalize before downloading."
                        : isOriginalSite
                            ? "Feature disabled for the Original design. Select a finalized design."
                            : ""}>
                        <Button
                            disabled={areChangesMade || isOriginalSite}
                            icon={<DownloadIcon size={20}/>}
                            type='primary' size='large' block onClick={() => openGenFilePopup()}>Export .Gen
                            File</Button>
                    </Tooltip>}
                </>
            }
        </>
    )
}

export default GenFileButton;